import {StateService} from "./state/state.service";
import {OrgDto} from "../repositories/dto/org.dto";
import {Observable, of} from "rxjs";
import {SearchFilterRequest, SearchRequest} from "../repositories/dto/search/search-table.dto.req";
import {filter, map} from "rxjs/operators";
import {nonBlank} from "../libs/utils/epic.utils";
import {WrapperDto} from "../repositories/dto/wrapper.dto";
import {SearchContactRes} from "../repositories/dto/search/search-contact.res";
import {StorageService} from "./storage/storage.service";
import {inject} from "@angular/core";
import {I18nService} from "./i18n/i18n.service";
import {LoggingService} from "./logger/logging.service";
import {RepoProvider} from "../repositories/repo.provider";

export abstract class AbstractService {

  protected readonly stateService: StateService = inject(StateService);
  protected readonly storageService: StorageService = inject(StorageService);
  protected readonly i18n: I18nService = inject(I18nService);
  protected readonly log: LoggingService = inject(LoggingService);
  protected readonly repoProvider: RepoProvider = inject(RepoProvider);

  private readonly cacheKeyPrefix: string = 'filter-value:';
  private readonly cacheExpireInSeconds: number = 5 * 60;
  private org: OrgDto | undefined;

  protected constructor() {
    this.stateService.getOrg().subscribe((o) => this.org = o);
  }

  protected getOrg(): OrgDto {
    return this.org ? this.org : new OrgDto();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected filterValueSearch(_request: SearchRequest): Observable<WrapperDto<SearchContactRes>> {
    return of(new WrapperDto<SearchContactRes>());
  }

  /**
   * override and impl filterValueSearch
   */
  protected getFilterValueByField(field: string): Observable<string[]> {
    const request = new SearchRequest({
      fields: ['timeversion'],
      pageSize: 0,
      filters: [new SearchFilterRequest({id: field, pos: 1, filterValueField: field})]
    });
    const key: string = this.cacheKeyPrefix + this.getOrg().id + ':' + field;
    return this.storageService.cache(key, () => {
      return this.filterValueSearch(request).pipe(
        map((w) => w.getFirstData()),
        filter((s) => s.filters.length > 0),
        map((s) => s.filters[0].values),
        map((fs) => fs
          .filter((f) => nonBlank(f.name))
          .map((f) => f.name)));
    }, this.cacheExpireInSeconds);
  }
}
